import { css } from 'styled-components';
import Theme from './theme';

const sizes = {
  xxs: 320,
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1280,
  xl: 1480
};

const breakpoints = {
  xxs: `(max-width: ${sizes.xxs}px)`,
  xs: `(max-width: ${sizes.xs}px)`,
  sm: `(max-width: ${sizes.sm}px)`,
  md: `(max-width: ${sizes.md}px)`,
  lg: `(max-width: ${sizes.lg}px)`
};

const maxQuery = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const minQuery = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

const withQuery = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = {
    down: () => `@media (max-width: ${sizes[label]}px)`,
    up: () => `@media (min-width: ${sizes[label]}px)`
  };
  return acc;
}, {});

const Themev2 = {
  ...Theme,
  colors: {
    ...Theme.colors,
    orange: '#ff5500',
    darkOrange: '#f55200',
    midOrange: '#E48A37',
    midLightOrange: '#FFEEE6',
    darkOrangeAux: '#E64D00',
    lightOrange: '#ffd8c5',
    creamLightOrange: '#FFE8DC',
    creamDarkOrange: '#FFCCAC',
    violet: '#3a0c3d',
    darkViolet: '#2f0d31',
    yellow: '#ffdB5e',
    darkYellow: '#F7CA4C',
    darkestYellow: '#F5BD00',
    negative: '#c60024',
    positive: '#34be34',
    blue: '#3a61ea',
    darkBlue: '#252a49',
    darkGray: '#68808C',
    midDarkGray: '#7c98a7',
    grayDarkLight: '#53768A',
    midDarkGrayAux: '#727272',
    midNeutralGray: '#C8C8C8',
    midLightGray: '#Cbd6dc',
    middleGray: '#e7eef0',
    neutralGray: '#F5F5F5',
    neutralDarkGray: '#EDEDED',
    neutralDarkGrayII: '#484848',
    lightGray: '#f3f7f8',
    black: '#000000',
    lightBlack: '#030117',
    white: '#ffffff',
    lightLilac: '#DCD9E6',
    violetStepper: '#513F84',
    positiveBack: '#F0FFF0',
    orangeBack: '#FFF2EB',
    redBack: '#FFEFF2',
    redNoTRecommended: '#D90D16',
    lightBlue: '#C2D7F7',
    blueGraph: '#3787F7',
    appleGreen: '#80BD00',
    snackGreen: '#008A00',
    greenRecommended: '#067f22',
    midDarkGreen: '#067F22',
    greenRecommendedBg: '#ebf4eb',
    lighterOrange: '#FCEED9',
    lightYellow: '#FFFAE8',
    creamOrange: '#FFEBEE',
    brownYellow: '#B1860C',
    transparent: '#00000000',
    midYellow: '#F7F2E1',
    midPositive: '#E9F7E9',
    midNegative: '#F7E8EB',
    blueBenvi: '#07358F',
    orangeVamx: '#CB333B',
    lightBlueVamx: '#037CC2',
    blueLinks: '#0064FF',
    grayBanvi: '#F8F9F5',
    darkBlueBenvi: '#3957bd',
    lightBlueBenvi: '#425ec4',
    feedbackGreen: '#2E6830',
    feedbackRed: '#A30A10',
    bgBanneri24Full: '#faf5fe',
    violeti24Full: '#330760',
    blueBenviFull: '#3957BD',
    purpleLightFull: '#FAF5FE',
    draftFull: '#6B4A8C',
    errorRed: '#d90d16',
    blueBannerInfo: '#0055C3',
    bannerInfoLightBlue: '#EFF7FE',
    hoverCta: '#e5e5e5'
  },
  breakpoints
};

export const select = key => Themev2.colors[key];

export { Themev2, breakpoints, withQuery, maxQuery, minQuery };
